import { createSagaActionTypes } from "../../../utils/actionFactory";

export const SUBMIT_NUMBER = "SUBMIT_NUMBER";

export const actions = createSagaActionTypes("CHECK_NUMBER", [SUBMIT_NUMBER]);
